import axios from 'axios';

const BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://express-server-gules-mu.vercel.app";

async function login(username, password) {
  try {
    const response = await axios.post(`${BASE_URL}/login`, {
      username: username,
      password: password
    });
    const token = response.data.token;
    localStorage.setItem('saporimiei-admin-token', token);
    return true;
  } catch (error) {
    console.error('Errore durante il login:', error.response.data.message);
    return false;
  }
}

export { login };